/**
 * Resolves the user-facing display name for a Portfolio Analysis row, given
 * the user's preferences. When `display.useAccountNicknames` is on AND the
 * row carries a populated nickname (Account-grouping rows always request
 * the Nickname group-info via buildOrionRequest's buildGroupingExtras),
 * returns the nickname; otherwise falls back to the canonical `row.name`.
 *
 * The predicate is `!== false` so legacy localStorage entries missing the
 * field still get today's default-on behavior.
 *
 * Single source of truth shared by the grid renderer (PortfolioExplorerGrid)
 * and the CSV/TSV exporter (lib/exportRows). Changes to nickname-display
 * rules (e.g. handling empty-string nicknames, future per-grouping rules)
 * land here so the two surfaces never drift.
 *
 * Note: benchmark rows (rendered by `renderBenchmarkRow`) intentionally
 * bypass this resolver and use `benchmark.name` directly. Benchmark labels
 * are reference series (e.g. "MSCI ACWI"), not Account names, and don't
 * carry nicknames -- routing them through here would be a no-op.
 */
export function resolveDisplayName (row, prefs) {
  const useNicknames = prefs?.display?.useAccountNicknames !== false
  const nickname = row?.nickname
  return (useNicknames && nickname) ? nickname : row?.name
}
